module.exports = __webpack_public_path__ + "static/media/stofferingen-42.62ec5dd2.jpg";